import { useState } from "react";
import Api from "../../../Api";
import classNames from "classnames";
import DiscreetMessage from "../../../parts/DiscreetMessage";
import { Category } from "../../../types";

type CategoryListProps = {
  categories: Category[];
  onSelect: (category: Category) => void;
  onCreate: () => void;
};
const CategoryList = ({
  categories,
  onSelect,
  onCreate,
}: CategoryListProps) => {
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [name, setName] = useState("");
  const [error, setError] = useState(false);

  const save = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(false);
    const result = await Api.equipmentsCreateCategory(name);

    if (!result.success) {
      setError(true);
    }

    if (result.success) {
      setShowCategoryForm(false);
      setError(false);
      setName("");
      onCreate();
    }
  };

  return (
    <div>
      {!categories && <DiscreetMessage text="Carregando ..." />}

      {categories && (
        <div className="flex flex-wrap items-start gap-4">
          {categories.map((category) => (
            <CategoryCard
              category={category}
              onClick={onSelect}
              key={category.uuid}
            />
          ))}

          {!showCategoryForm && (
            <div
              className="rounded-lg py-4 px-6 font-semibold bg-gray-100 text-gray-500 border-gray-400 border-2 border-dashed opacity-50 hover:opacity-100 cursor-pointer"
              onClick={() => setShowCategoryForm(true)}
            >
              Criar nova
            </div>
          )}

          {showCategoryForm && (
            <div className="border rounded-lg">
              <form onSubmit={save} className="flex flex-col">
                <input
                  className={classNames("border rounded m-4 py-2 px-4", {
                    "border-red-700": error,
                  })}
                  autoFocus
                  placeholder="Nome"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />

                <button className="rounded-b bg-sky-600 hover:bg-sky-500 text-white font-extrabold p-2">
                  Criar
                </button>
              </form>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryList;

const CategoryCard = ({
  category,
  onClick,
}: {
  category: Category;
  onClick: (category: Category) => void;
}) => (
  <div
    className="border rounded-lg shadow-sm py-4 px-6 font-bold cursor-pointer hover:bg-slate-50"
    onClick={() => onClick(category)}
  >
    {category.name}
  </div>
);
